var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDandelionColIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.93 94.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.93,
    height: 94.93,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.89,
    y: 27.07,
    width: 7.15,
    height: 67.86,
    style: {
      fill: "#569b32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,34.75c0,.91-7.15.91-7.15,0V24.82H51Z",
    style: {
      fill: "#487c2a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.46,
    cy: 15.51,
    r: 15.51,
    style: {
      fill: "#cecdc8"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.47,
    y1: 15.51,
    x2: 61.33,
    y2: 15.51,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.55,
    y1: 25.36,
    x2: 57.25,
    y2: 5.66,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.55,
    y1: 5.66,
    x2: 57.25,
    y2: 25.36,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.4,
    y1: 1.58,
    x2: 47.4,
    y2: 29.44,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.02,
    y1: 2.66,
    x2: 52.78,
    y2: 28.36,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.43,
    y1: 10.43,
    x2: 60.37,
    y2: 20.59,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 28.35,
    x2: 52.79,
    y2: 2.67,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.54,
    y1: 20.88,
    x2: 60.25,
    y2: 10.14,
    style: {
      fill: "none",
      stroke: "#bcbcbb",
      strokeMiterlimit: 10
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDandelionColIcon);
export default __webpack_public_path__ + "static/media/dandelion_col_icon.0fffe8ece48f37eb1a559c3131489ca6.svg";
export { ForwardRef as ReactComponent };